/**
 * Custom Tag Component
 * Extends Ant Design Tag with custom styling
 */

import { Tag as AntTag, TagProps } from 'antd';
import classNames from 'classnames';
import './CustomTag.scss';

export interface CustomTagProps extends TagProps {
  /** Tag variant */
  variant?: 'default' | 'outlined' | 'filled';
}

/**
 * CustomTag Component
 */
export const CustomTag: React.FC<CustomTagProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const tagClasses = classNames('custom-tag', `custom-tag--${variant}`, className);

  return <AntTag {...rest} className={tagClasses} />;
};

export default CustomTag;

